<template>
  <div>
    <PageTitle title="Accounting" />
    <v-container fluid>
      <v-card class="pa-4 mb-4">
        <v-row align="end">
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="start" label="From" type="date" outlined dense hide-details />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="end" label="To" type="date" outlined dense hide-details />
          </v-col>
          <v-col cols="12" sm="auto" class="d-flex">
            <v-btn color="primary" height="40" :loading="loading" @click="load">Apply</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-row v-if="report">
        <v-col v-for="card in kpiCards" :key="card.label" cols="12" sm="6" md="3">
          <v-card class="pa-4">
            <div class="text-caption grey--text">{{ card.label }}</div>
            <div class="text-h6">{{ card.value | formatCurrency }}</div>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="report">
        <v-col cols="12" md="6">
          <v-card class="pa-4">
            <div class="text-subtitle-1 mb-3">Income</div>
            <v-simple-table>
              <tbody>
                <tr v-for="row in incomeRows" :key="row.label">
                  <td>{{ row.label }}</td>
                  <td class="text-right">{{ row.billed | formatCurrency }}</td>
                  <td class="text-right">{{ row.received | formatCurrency }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="pa-4">
            <div class="text-subtitle-1 mb-3">Operating expenses</div>
            <v-simple-table>
              <tbody>
                <tr v-for="row in expenseRows" :key="row.name">
                  <td>{{ row.name }}</td>
                  <td class="text-right">{{ row.amount | formatCurrency }}</td>
                </tr>
                <tr v-if="!expenseRows.length">
                  <td colspan="2">No operating expenses in this period.</td>
                </tr>
              </tbody>
            </v-simple-table>
            <div class="mt-4 text-subtitle-2">Procurement</div>
            <div>Purchases {{ procurement.purchase_payments | formatCurrency }}</div>
            <div>Purchase returns {{ procurement.purchase_return_refunds | formatCurrency }}</div>
            <div>Net {{ procurement.net_procurement | formatCurrency }}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import axios from "@/plugins/axios";

export default {
  data() {
    return {
      start: moment().startOf("month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      loading: false,
      report: null,
    };
  },
  computed: {
    kpis() {
      return (this.report && this.report.kpis) || {};
    },
    kpiCards() {
      return [
        { label: "Revenue", value: this.kpis.revenue_accrual },
        { label: "Cash received", value: this.kpis.revenue_cash },
        { label: "Outstanding", value: this.kpis.outstanding_receivables },
        { label: "Operating expenses", value: this.kpis.operating_expenses },
        { label: "Net procurement", value: this.kpis.net_procurement },
        { label: "Gross operating profit", value: this.kpis.gross_operating_profit },
        { label: "Net profit", value: this.kpis.net_profit },
        { label: "Cash position", value: this.kpis.cash_position },
      ];
    },
    incomeRows() {
      const streams = (this.report && this.report.income_streams) || {};
      return [
        { label: "Rooms", billed: streams.reservation && streams.reservation.billed_amount, received: streams.reservation && streams.reservation.received_amount },
        { label: "Restaurant", billed: streams.restaurant && streams.restaurant.billed_amount, received: streams.restaurant && streams.restaurant.received_amount },
        { label: "Sales", billed: streams.sales && streams.sales.billed_amount, received: streams.sales && streams.sales.received_amount },
        { label: "Other income", billed: streams.manual && streams.manual.billed_amount, received: streams.manual && streams.manual.received_amount },
      ];
    },
    expenseRows() {
      const operating = this.report && this.report.expense_breakdown && this.report.expense_breakdown.operating;
      return (operating && operating.categories) || [];
    },
    procurement() {
      const procurement = this.report && this.report.expense_breakdown && this.report.expense_breakdown.procurement;
      return procurement || {};
    },
  },
  methods: {
    load() {
      this.loading = true;
      axios
        .get("accounting/dashboard", { params: { start: this.start, end: this.end } })
        .then((res) => {
          this.report = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$toast.error("Could not load accounting report");
        });
    },
  },
  created() {
    this.load();
  },
};
</script>
